import {
  put,
  call,
  take,
  every,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import * as API from "../../Services/ApiCalls";

function* emailTempListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.EMAIL_TEMP_LIST, payload);
    if (response.status == 200) {
      yield put(ACTION.emailTemp_Success(response.data));
    } else {
      yield put(ACTION.emailTempId_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.emailTempId_Fail(response.data.error));
  }
}
function* emailTempIdsaga({ payload, callBack }) {
  try {
    const response = yield call(API.EMAIL_TEMP_ID, payload);
    if (response.status == 200) {
      yield put(ACTION.emailTempId_Success(response.data));
    } else {
      yield put(ACTION.emailTempId_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.emailTempId_Fail(response.data.error));
  }
}
function* updateEmailTempSaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_EMAIL_TEMP, payload);
    if (response.data.status == 200) {
      yield put(ACTION.updateEmailtemp_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.updateEmailtemp_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.updateEmailtemp_Fail(response.data.error));
  }
}
function* addEmailTempSaga({ payload, callBack }) {
  try {
    const response = yield call(API.ADD_EMAIL_TEMP, payload);
    if (response.data.status == 200) {
      yield put(ACTION.addEmailTemp_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.addEmailTemp_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.addEmailTemp_Fail(response.data.error));
  }
}
function* deleteEmailTempSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_EMAIL_TEMP, payload);
    if (response.data.status == 200) {
      yield put(ACTION.deleteEmailTemp_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.deleteEmailTemp_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteEmailTemp_Fail(response.data.error));
  }
}

// SMS ===================== //

function* smsTempListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.SMS_TEMP_LIST, payload);
    if (response.status == 200) {
      yield put(ACTION.smsTemp_Success(response.data));
    } else {
      yield put(ACTION.smsTempId_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.smsTempId_Fail(response.data.error));
  }
}
function* smsTempIdsaga({ payload, callBack }) {
  try {
    const response = yield call(API.SMS_TEMP_ID, payload);
    if (response.status == 200) {
      yield put(ACTION.smsTempId_Success(response.data));
    } else {
      yield put(ACTION.smsTempId_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.smsTempId_Fail(response.data.error));
  }
}
function* updateSmsTempSaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_SMS_TEMP, payload);
    if (response.data.status == 200) {
      yield put(ACTION.updateSMStemp_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.updateSMStemp_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.updateSMStemp_Fail(response.data.error));
  }
}
function* addSmsTempSaga({ payload, callBack }) {
  try {
    const response = yield call(API.ADD_SMS_TEMP, payload);
    if (response.data.status == 200) {
      yield put(ACTION.addSMSTemp_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.addSMSTemp_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.addSMSTemp_Fail(response.data.error));
  }
}
function* deleteSmsTempSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_SMS_TEMP, payload);
    if (response.data.status == 200) {
      yield put(ACTION.deleteSMSTemp_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.deleteSMSTemp_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteSMSTemp_Fail(response.data.error));
  }
}

function* emailTempByTypeSaga({ payload, callBack }) {
  try {
    const response = yield call(API.EMAIL_TEMP_BY_TYPE, payload);
    if (response.data.status == 200) {
      yield put(ACTION.emailTempByType_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.emailTempByType_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.emailTempByType_Fail(response.data.error));
  }
}

function* smsTempByTypeSaga({ payload, callBack }) {
  try {
    const response = yield call(API.SMS_TEMP_BY_TYPE, payload);
    if (response.data.status == 200) {
      yield put(ACTION.smsTempByType_Success(response.data));
      callBack && callBack(response.data);
    } else {
      yield put(ACTION.smsTempByType_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.smsTempByType_Fail(response.data.error));
  }
}

function* EmailTempSaga() {
  yield takeEvery(CONST.EMAIL_TEMP_LIST, emailTempListSaga);
  yield takeEvery(CONST.EMAIL_TEMP_ID, emailTempIdsaga);
  yield takeEvery(CONST.UPDATE_EMAIL_TEMP, updateEmailTempSaga);
  yield takeEvery(CONST.ADD_EMAIL_TEMP, addEmailTempSaga);
  yield takeEvery(CONST.DELETE_EMAIL_TEMP, deleteEmailTempSaga);
  yield takeEvery(CONST.EMAIL_TEMP_BY_TYPE, emailTempByTypeSaga);

  yield takeEvery(CONST.SMS_TEMP_LIST, smsTempListSaga);
  yield takeEvery(CONST.SMS_TEMP_ID, smsTempIdsaga);
  yield takeEvery(CONST.UPDATE_SMS_TEMP, updateSmsTempSaga);
  yield takeEvery(CONST.ADD_SMS_TEMP, addSmsTempSaga);
  yield takeEvery(CONST.DELETE_SMS_TEMP, deleteSmsTempSaga);
  yield takeEvery(CONST.SMS_TEMP_BY_TYPE, smsTempByTypeSaga);
}

export default EmailTempSaga;
